import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teaching',
  templateUrl: './teaching.component.html',
  styleUrls: ['./teaching.component.less']
})
export class TeachingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
